class QuickBuyModal extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleModalClick = this.handleModalClick.bind(this)

    this.listeners.add(document, 'keydown', this.handleKeyDown)
    this.listeners.add(this, 'click', this.handleModalClick)

    this.els?.close?.elements?.forEach(close => {
      this.listeners.add(close, `click`, this.handleClose)
    })
  }

  get isOpen () {
    return this.getAttribute('aria-hidden') === 'false'
  }

  show () {
    this.activeTrigger = document.activeElement

    document.body.classList.toggle('util-SiteOverflowed', true)
    this.setAttribute('aria-hidden', 'false')
    this.focusFirstElement()
  }

  handleModalClick (event) {
    if (
      event.target.closest(
        '[data-drawers-trigger], [data-drawers-close], [data-drawers-close-all], [data-drawers-back-key]',
      )
    ) {
      return
    }

    event.stopPropagation()
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')

    if (!document.body.classList.contains('util-Search-open')) {
      document.body.classList.toggle('util-SiteOverflowed', false)
    }

    this.returnFocus()
  }

  focusFirstElement () {
    setTimeout(() => {
      const focusTarget =
        this.querySelector('button[data-quick-buy-modal-el="close"]') ||
        this.getFocusableElements()[0]
      if (focusTarget) focusTarget.focus()
    }, 350)
  }

  returnFocus () {
    if (this.activeTrigger) {
      this.activeTrigger.focus()
      this.activeTrigger = null
    }
  }

  handleKeyDown (event) {
    if (!this.isOpen) return

    if (event.key === 'Escape') {
      this.handleClose()
      return
    }

    if (event.key === 'Tab') {
      this.trapFocus(event)
    }
  }

  trapFocus (event) {
    const focusableEls = this.getFocusableElements()
    if (!focusableEls.length) return

    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]

    if (!this.contains(document.activeElement)) {
      event.preventDefault()
      firstFocusableEl.focus()
      return
    }

    if (event.shiftKey && document.activeElement === firstFocusableEl) {
      event.preventDefault()
      lastFocusableEl.focus()
    } else if (!event.shiftKey && document.activeElement === lastFocusableEl) {
      event.preventDefault()
      firstFocusableEl.focus()
    }
  }

  getFocusableElements () {
    return Array.from(
      this.querySelectorAll(
        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="email"]:not([disabled]), input[type="tel"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
      ),
    ).filter(el => !el.closest('[hidden]') && el.getClientRects().length > 0)
  }
}

if (!customElements.get('quick-buy-modal')) {
  customElements.define('quick-buy-modal', QuickBuyModal)
}

class QuickBuyModalForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    if (this.formEl.dataset.zakekeProduct === 'true') {
      this.handleZakekeProduct = this.handleZakekeProduct.bind(this)
      this.listeners.add(this.submitBtnEl, 'click', this.handleZakekeProduct)
    } else {
      // Product form handles the add to cart - we dont need to fire it twice
      // Just close the modal.
      this.closeModal = this.closeModal.bind(this)
      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
        this.closeModal,
      )
    }
  }

  closeModal (et) {
    this.modalEl?.handleClose()

    const cartEvent = new CustomEvent('quickBuy:added')

    document.dispatchEvent(cartEvent)
  }

  handleZakekeProduct (evt) {
    evt.preventDefault()
    evt.stopPropagation()

    const pid = this.formEl.querySelector('input[name="zakeke-product-id"]')
      .value

    const originalAction = this.formEl.action
    this.formEl.action = `${window.zakekeUrl || '/apps/zakeke'}?pid=${pid}`

    window.onpageshow = function (event) {
      if (event.persisted) {
        this.formEl.action = originalAction
      }
    }

    this.formEl.submit()
  }

  get modalEl () {
    return this.externalEls?.modal?.element
  }

  get formEl () {
    return this.els?.form?.element
  }

  get submitBtnEl () {
    return this.els?.button?.element
  }

  get optionChoicesEl () {
    return this.containerEl?.querySelector(
      '[data-product-variant-dropdown-external-el="option-choice"]',
    )
  }

  get containerEl () {
    return this.closest(
      '[data-product-variant-dropdown-external-el="container"]',
    )
  }
}

if (!customElements.get('quick-buy-modal-form')) {
  customElements.define('quick-buy-modal-form', QuickBuyModalForm)
}
